import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import { Mark } from '@tiptap/core';
const Direction = Mark.create({
  name: 'direction',
  addOptions() {
    return {
      types: ['heading', 'paragraph', 'bulletList', 'orderedList', 'placeholder'],
      directions: ['ltr', 'rtl', null],
      defaultDirection: null
    };
  },
  addGlobalAttributes() {
    return [{
      types: this.options.types,
      attributes: {
        dir: {
          default: this.options.defaultDirection,
          parseHTML: element => {
            let dir = element.dir;
            if (!this.options.directions.includes(dir)) {
              dir = this.options.defaultDirection;
            }
            return dir;
          },
          renderHTML: attributes => {
            let dir = attributes.dir;
            if (!this.options.directions.includes(attributes.dir)) {
              dir = this.options.defaultDirection;
            }
            return {
              dir: dir
            };
          }
        }
      }
    }];
  },
  addCommands() {
    return {
      setDirection: direction => arg => {
        return arg.chain().command(({
          commands
        }) => {
          if (!this.options.directions.includes(direction)) return;
          return this.options.types.every(type => {
            commands.updateAttributes(type, {
              dir: direction
            });
            return true;
          });
        }).run();
      },
      unsetDirection: () => ({
        chain
      }) => {
        return chain().command(({
          commands
        }) => {
          return this.options.types.every(type => {
            commands.resetAttributes(type, 'dir');
            return true;
          });
        }).run();
      }
    };
  }
});
export default Direction;